import styled from "@emotion/styled";
import { CircleIcon } from "../../icon/circle-icon/circle-icon.component";
import { BASE_COLORS } from "../../../emotion-theme";

export const DrawerControlButton = styled(CircleIcon)`
  box-shadow: 0 2px 4px 2px ${BASE_COLORS.lightGrey};
  width: 32px;
  height: 32px;
  margin: 0;
  line-height: 24px;
  z-index: 100;
  &,
  &:hover {
    background-color: ${BASE_COLORS.white};
  }
`;
